import { useTranslation } from 'react-i18next'
import SearchBar from '@/common/SearchBar'

interface Props {
  isFetching?: boolean
}

export default function FrameSearchInput({ isFetching }: Props) {
  const { t } = useTranslation(['frame'])

  return (
    <SearchBar
      label={t('frame:search.input.label')}
      placeholder={t('frame:search.input.placeholder')}
      isFetching={isFetching}
    />
  )
}
